<template>
  <a href="#" @click.prevent="openPreRegister">Pre-register Now</a>
</template>

<script setup>
import {getFullstackUrl} from "@/composables/useFullstackUrl";
import {getUrlWithAuth} from "@/composables/useUrlWithAuth";
const preRegisterUrl = `${getFullstackUrl()}/#pre-register`;
const openPreRegister = () => (window.location = getUrlWithAuth(preRegisterUrl));
</script>

<style scoped>
a {
  white-space: nowrap;
  font-weight: bold;
  color: white;
  background-color: var(--brand-color);
  padding: 0.6rem 2.3rem;
  border-radius: 17px;
  text-align: center;
  text-decoration: none;
  cursor: pointer;
}
:is(a:hover, a:focus) {
  background-color: var(--brand-hover-color);
  color: white;
  outline: none;
  text-decoration: none; /* global.css underlines a:hover; a button needs only the colour change */
}
a:active {
  background-color: var(--brand-hover-color);
}
</style>
